import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import SearchLayout from './layout';
import SearchNavigation from './navigation';
import searchRoutes from './routes';
import styles from './SearchScreen.module.scss';

/**
 * SearchScreen
 *
 * @return {JSX.Element}
 */
const SearchScreen = ({ className }) => {
  return (
    <SearchLayout
      className={classNames(
        styles.SearchScreen,
        className,
        `${SearchScreen.displayName}`
      )}
      routes={searchRoutes}
    >
      <Helmet title="Search" />
      <SearchNavigation routes={searchRoutes} />
    </SearchLayout>
  );
};

SearchScreen.displayName = 'SearchScreen';

export default SearchScreen;
